import React, { useEffect, useState } from 'react';
import UsersService from "services/http/users-service";
import jwtWorker from 'utils/jwt-worker';
import { Spinner } from "components/shared";


export const Logout = (props) => {

    const [loader, setLoader] = useState();
    const [error, setError] = useState();

    useEffect(() => {
        logout();
    }, []);

    function logout() {
        setLoader(true);
        UsersService.logout({ username: jwtWorker.getSubFromToken(), token: jwtWorker.getTokenFromStorage() }).then(() => { }, error => {
            setError(error);
        }).finally(() => {
            Promise.resolve(jwtWorker.removeTokenFromStorage()).finally(() => {
                window.location.reload();
            });
        });
    }

    return (
        <>
            {loader && <Spinner color="#ED1C24" label='logging out... ' />}
            {error && <span className='logging-out-loader'>{error}</span>}
        </>
    );
}